// extracted by mini-css-extract-plugin
var _1 = "contactSupport-module_contactButtonWrapper_kDKXt";
var _2 = "contactSupport-module_contactInputWrapper_ACJwZ";
var _3 = "contactSupport-module_contactInputWrapper1_C_pUH";
var _4 = "contactSupport-module_contactPrevbuttonWrapper_Bg1LW";
var _5 = "contactSupport-module_contactSupportWrapper_onqh8";
export { _1 as "contactButtonWrapper", _2 as "contactInputWrapper", _3 as "contactInputWrapper1", _4 as "contactPrevbuttonWrapper", _5 as "contactSupportWrapper" }
